export default {
  header: 'Pages',
  icon: 'FileIcon',
  children: [],
}
